import React from 'react'
import { Provider } from 'react-redux'
import { store } from './store'

export interface Props {
    children: React.ReactNode
}

export const FeatureStateProvider: React.FC<Props> = ({ children }) => {
    return <Provider store={store}>{children}</Provider>
}

export default FeatureStateProvider
